import { format } from 'date-fns';
import React, { useEffect } from 'react';

import * as S from './styles';


export function MessagesTableAncora({ message, statusPropose, operationConclusionAncora }) {
  if (operationConclusionAncora[0]?.antecipacaoConclusaoAncoraId <= 0 || statusPropose) {
    return null;
  }
  return (
    operationConclusionAncora?.[0]?.antecipacaoConclusaoAncoraId > 0 && (
      <S.MessageContainer>
        <S.TableTitleHeader>
          <h3 className="operation-title">Antecipação - Resposta da Rede</h3>
        </S.TableTitleHeader>
        <S.MessageBody>
          <p className="message-text">
            {operationConclusionAncora?.[0]?.conclusao} por {operationConclusionAncora?.[0]?.nome}
          </p>
          <p className="message-text">
            {format(new Date(operationConclusionAncora[0]?.dataRegistro), 'dd/MM/yy HH:mm')}
            <span className="message-ip">IP: {operationConclusionAncora[0]?.ip}</span>
          </p>
          {operationConclusionAncora[0]?.mensagem && (
            <p className="message-text">Mensagem: {operationConclusionAncora[0]?.mensagem}</p>
          )}
        </S.MessageBody>
      </S.MessageContainer>
    )
  );
}
